// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"UnidadesTable_spinnerContainer__s+E7l","botonAdd":"UnidadesTable_botonAdd__UVMCG"};